export const FETCH_LIST_ALL_TEMPLATE_TASK_REQUEST = 'FETCH_LIST_ALL_TEMPLATE_TASK_REQUEST'
export const FETCH_LIST_ALL_TEMPLATE_TASK_SUCCESS = 'FETCH_LIST_ALL_TEMPLATE_TASK_SUCCESS'
export const FETCH_LIST_ALL_TEMPLATE_TASK_FALUIRE = 'FETCH_LIST_ALL_TEMPLATE_TASK_FALUIRE'
export const FETCH_LIST_ALL_TEMPLATE_TASK_MINUUS_ONE_FALUIRE = 'FETCH_LIST_ALL_TEMPLATE_TASK_MINUUS_ONE_FALUIRE'
export const FETCH_LIST_ALL_TEMPLATE_TASK_COUNT_REQUEST='FETCH_LIST_ALL_TEMPLATE_TASK_COUNT_REQUEST'
export const SEARCH_ALL_TASK='SEARCH_ALL_TASK'